import { render, staticRenderFns } from "./ResetPdQl.vue?vue&type=template&id=59885257&scoped=true"
import script from "./ResetPdQl.vue?vue&type=script&lang=js"
export * from "./ResetPdQl.vue?vue&type=script&lang=js"
import style0 from "./ResetPdQl.vue?vue&type=style&index=0&id=59885257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59885257",
  null
  
)

export default component.exports